export default __webpack_public_path__ + "791f25553361d1fb6fe8e5d81f96b203.svg";